import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import '../../services/GlobalVariables';
import axios from 'axios';

const API_URL = global.SET_API_URL + 'promoCodes/';

const initialState = {
    promoCodes: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ''
};

export const fetchPromoCodes = createAsyncThunk(
    'promoCodes/fetchAll',
    async (_, thunkAPI) => {
        try {
            const state = thunkAPI.getState();
            const branchID = state.auth?.user?.defaultBranchID || null;
            const queryPart = branchID ? `?branchID=${branchID}` : '';
            const res = await axios.get(API_URL + `list${queryPart}`);
            return res.data.promos || [];
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const createPromoCode = createAsyncThunk(
    'promoCodes/create',
    async (payload, thunkAPI) => {
        try {
            const res = await axios.post(API_URL + 'create', payload);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const updatePromoCode = createAsyncThunk(
    'promoCodes/update',
    async ({ promoID, data }, thunkAPI) => {
        try {
            const res = await axios.put(API_URL + `update/${promoID}`, data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const updatePromoCodeStatus = createAsyncThunk(
    'promoCodes/status',
    async (payload, thunkAPI) => {
        try {
            const res = await axios.put(API_URL + 'status', payload);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const deletePromoCode = createAsyncThunk(
    'promoCodes/delete',
    async (promoID, thunkAPI) => {
        try {
            const res = await axios.delete(API_URL + `delete/${promoID}`);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

const promoCodesSlice = createSlice({
    name: 'promoCodes',
    initialState,
    reducers: {
        reset: (state) => {
            state.isLoading = false;
            state.isError = false;
            state.isSuccess = false;
            state.message = '';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPromoCodes.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchPromoCodes.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.promoCodes = action.payload;
            })
            .addCase(fetchPromoCodes.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(createPromoCode.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(createPromoCode.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.message = action.payload.message;
            })
            .addCase(createPromoCode.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(updatePromoCode.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updatePromoCode.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.message = action.payload.message;
            })
            .addCase(updatePromoCode.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(updatePromoCodeStatus.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updatePromoCodeStatus.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.message = action.payload.message;
            })
            .addCase(updatePromoCodeStatus.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(deletePromoCode.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(deletePromoCode.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.message = action.payload.message;
            })
            .addCase(deletePromoCode.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            });
    }
});

export const { reset } = promoCodesSlice.actions;
export default promoCodesSlice.reducer;
